<template>
  <div class="animated fadeIn container-fluid">
    <h4 v-text="'操作次數統計 Logs Summary'"></h4>

    <div class="proj-toolbox-area">
      <b-row>
        <b-col md="8">
          <div class="text-center">
            <!-- <h5>View Mode</h5> -->
            <b-button-group class="block-sm">
              <b-button
                variant="outline-dark"
                :pressed="log_period == 'week'"
                @click="log_period = 'week'"
              >
                <i class="fa fa-th-large"></i> Week
              </b-button>
              <b-button
                variant="outline-dark"
                :pressed="log_period == 'month'"
                @click="log_period = 'month'"
              >
                <i class="fa fa-table"></i> Month
              </b-button>
            </b-button-group>
          </div>
        </b-col>
        <b-col md="4">
          <SearchTool
            :list_data="list_logs"
            :search_key="['user_id', 'user', 'note']"
            :search_tooltip="''"
            @search-result="search_result = $event"
          ></SearchTool>
        </b-col>
      </b-row>

      <div class="edit-area" v-if="search_result && search_result.length > 0">
        <b-row align-h="end">
          <b-col md="8" class="text-center" v-if="log_range">
            {{ log_range }}
          </b-col>
          <b-col md="4">
            <b-form-group
              label-cols-md="4"
              :label="$t('menu.per_page')"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="list-table-result scroll-style-gray overflow-x">
          <b-table
            hover
            small
            responsive="xl"
            :fields="table_fields"
            :items="table_items"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <!-- A virtual column -->
            <template #cell(see_user)="row">
              <b-button
                size="sm"
                class="btn-warning"
                @click.right="
                  goToPage('Edit User', { userID: row.item.user_id }, true)
                "
                @click="
                  goToPage('Edit User', { userID: row.item.user_id }, false)
                "
              >
                <!-- <i class="fa fa-gear block-text"></i> -->
                See User
              </b-button>
            </template>

            <template #cell(note)="row">
              <code class="text-muted">{{ row.item.note }}</code>
            </template>
          </b-table>

          <!-- 分頁 -->
          <div v-if="perPage">
            <b-pagination
              v-model="currentPage"
              :total-rows="table_items.length"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-else>
        <NoData></NoData>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AgriLoading from "@/views/components/AgriLoading";
import SearchTool from "@/views/components/SearchTool";
import NoData from "@/views/components/NoData";

export default {
  components: {
    AgriLoading,
    SearchTool,
    NoData,
  },
  data() {
    return {
      loading_showInfo: false,
      timezone: "Asia/Taipei",
      dateRange: undefined,
      list_logs: [],
      search_result: [],
      log_period: "week", // 'month
      log_type: undefined,
      log_range: undefined,

      // table
      table_items: [],
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
        { value: undefined, text: "all" },
      ],
    };
  },
  mounted() {
    this.timezone = this.$tools.date.getTimezoneNow();
    this.getData_Records();
  },
  computed: {
    ...mapState({}),

    table_fields() {
      return [
        { key: "see_user", sortable: false, label: undefined },
        { key: "idx", sortable: true, label: undefined },
        { key: "user_id", sortable: true, label: "User ID" },
        { key: "user", sortable: true, label: undefined },

        { key: "read", sortable: true, label: "讀取" },
        { key: "write", sortable: true, label: "寫入" },
        { key: "delete", sortable: true, label: "刪除" },
        { key: "authorization", sortable: true, label: "登入" },

        { key: "total_count", sortable: true, label: "總計筆數" },
        { key: "note", sortable: true, label: "User Note" },
        // { key: 'details',    sortable: false,    label: this.$t('menu.detail') },
      ];
    },
  },
  watch: {
    search_result(val, oldVal) {
      if (val) {
        this.arrangeTableData();
      }
    },

    log_period(val, oldVal) {
      this.getData_Records();
    },
  },
  methods: {
    goToPage: function (name, params = {}, openNewTab = false) {
      this.$tools.ui.goToPage(this.$router, name, params, openNewTab);
    },

    getData_Records() {
      this.loading_showInfo = true;
      this.list_logs = [];

      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Get_OPLogs_Summary", {
          period: this.log_period,
          type: this.log_type,
        }),
      };
      this.$http(options)
        .then((res) => {
          this.loading_showInfo = false;

          let _all_logs = [];

          if (res.data.start_time) {
            this.log_range = this.$tools.date.dateTimeZone(
              res.data.start_time,
              this.timezone,
              "YYYY-MM-DD HH:mm:ss"
            );
            this.log_range +=
              " ~ " +
              this.$tools.date.getDateNow(this.timezone, "YYYY-MM-DD HH:mm:ss");
          } else this.log_range = undefined;

          if (res.data.oplog_count) {
            res.data.oplog_count.forEach((_log) => {
              let _new_log = {
                user_id: _log.user_id,
                user:
                  _log.user_info.first_name + " " + _log.user_info.last_name,

                read: _log.detail.read ? _log.detail.read.count : 0,
                write: _log.detail.write ? _log.detail.write.count : 0,
                delete: _log.detail.delete ? _log.detail.delete.count : 0,
                authorization: _log.detail.authorization
                  ? _log.detail.authorization.count
                  : 0,

                total_count: _log.total_count,
                note: _log.user_info.note,
              };

              _all_logs.push(_new_log);
            });

            this.list_logs = _all_logs;
          }
        })
        .catch((err) => {
          this.loading_showInfo = false;
        });
    },

    arrangeTableData() {
      let _items = [];
      this.search_result.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-area {
  padding: 10px 15px;
}

.detail-key {
  display: inline-block;
  margin-left: 10px;
  color: #257d57;
}
.detail-title {
  display: inline-block;
  margin-left: 10px;
  color: #0086b3;
}
.detail-item {
  display: inline-block;
  margin-left: 10px;
}
</style>
